<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms" [selectedIndex]="0">
  <div class="layout-container">
    <mat-tab label="{{ 'MEETING_SCHEDULER.MEETING_LIST.CALENDAR' | translate }}">
      <ng-container *ngTemplateOutlet="calendarTemplate"></ng-container>
    </mat-tab>

    <mat-tab label="{{ 'MEETING_SCHEDULER.MEETING_LIST.SETTINGS' | translate }}">
      <ng-container *ngTemplateOutlet="(isLoading$ | async) ? loader : settingsTemplate"></ng-container>
    </mat-tab>
  </div>
</mat-tab-group>

<ng-template #loader>
  <div class="mat-elevation-z1 shimmer-container">
    @for (_ of [].constructor(16); track _) {
      <div class="stencil-shimmer shimmer"></div>
    }
  </div>
</ng-template>

<div class="layout-container">
  <ng-template #settingsTemplate>
    <div class="pad-style">
      @if (!isTableView) {
        <glxy-alert type="info" class="alert-large">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.ALERT_MESSAGE' | translate }}
          <button (click)="showTableView()" class="alert-link-button">
            {{ 'MEETING_SCHEDULER.MEETING_LIST.ALERT_MESSAGE_LINK' | translate }}
          </button>
        </glxy-alert>
      }
    </div>
    <div class="section-spacer"></div>

    <div class="button-section">
      @if (!isTableView) {
        <span class="section-header-text">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.PERSONAL_SECTION_HEADER' | translate }}
        </span>
      }
      @if (isTableView) {
        <div>
          <div class="section-spacer"></div>
          <mat-button-toggle-group class="blue-toggle" [value]="selectedToggle" (valueChange)="onToggleChange($event)">
            <mat-button-toggle value="events">
              {{ 'MEETING_SCHEDULER.MEETING_LIST.EVENTS' | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="group">{{
              'MEETING_SCHEDULER.MEETING_LIST.GROUP' | translate
            }}</mat-button-toggle>
            <mat-button-toggle value="service">{{
              'MEETING_SCHEDULER.MEETING_LIST.SERVICE' | translate
            }}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      }

      @if (selectedToggle === 'group') {
        <div>
          @if (personalCalendar$ | async; as personalCalendar) {
            <glxy-button-group>
              @if (groupPageLink$ | async; as groupPagelink) {
                <button
                  class="dropdown-icon large-button"
                  mat-flat-button
                  color="primary"
                  (click)="navigateToGroups(groupPagelink)"
                >
                  <mat-icon>add</mat-icon>
                  <h3 class="heading">
                    {{ category }}
                  </h3>
                </button>
              }
            </glxy-button-group>
          }
        </div>
      }

      @if (selectedToggle === 'service') {
        <div>
          @if (personalCalendar$ | async; as personalCalendar) {
            <glxy-button-group>
              @if (servicePageLink$ | async; as servicePageLink) {
                <button
                  class="dropdown-icon large-button"
                  mat-flat-button
                  color="primary"
                  (click)="navigateToGroups(servicePageLink)"
                >
                  <mat-icon>add</mat-icon>
                  <h3 class="heading">
                    {{ category }}
                  </h3>
                </button>
              }
            </glxy-button-group>
          }
        </div>
      }

      @if (!isTableView) {
        @if (personalCalendar$ | async; as personalCalendar) {
          <ng-template
            *ngTemplateOutlet="newEventTypeButton; context: { calendarId: personalCalendar.id }"
          ></ng-template>
          @if (!isTableView || selectedToggle === 'events') {
            <span class="button-container">
              <button mat-flat-button color="primary" (click)="showCardView()">
                <mat-icon>view_module</mat-icon> {{ 'MEETING_SCHEDULER.MEETING_LIST.CARDVIEW' | translate }}
              </button>
              <button mat-stroked-button color="primary" (click)="showTableView()">
                <mat-icon>view_headline</mat-icon> {{ 'MEETING_SCHEDULER.MEETING_LIST.TABLEVIEW' | translate }}
              </button>
            </span>
          }
        }
      }

      @if (isTableView && selectedToggle === 'events') {
        <div>
          <glxy-button-group>
            <button class="dropdown-icon large-button" mat-flat-button color="primary" [matMenuTriggerFor]="saveMenu">
              <mat-icon>add</mat-icon>
              <h3 class="heading">
                {{ category }}
              </h3>
            </button>
          </glxy-button-group>
          <mat-menu #saveMenu="matMenu">
            @if (personalCalendar$ | async; as personalCalendar) {
              <button mat-menu-item>
                @if (eventTypePageLink$ | async; as eventTypePageLink) {
                  <a (click)="handleEventTableCreate(eventTypePageLink, personalCalendar.id)" class="black-link">
                    {{ 'MEETING_SCHEDULER.MEETING_LIST.PERSONAL_EVENT_TYPE' | translate }}
                  </a>
                }
              </button>
            }
            @if (selectedGroupCalendarId$$.asObservable() | async; as selectedGroupCalendarId) {
              <button mat-menu-item>
                @if (eventTypePageLink$ | async; as eventTypePageLink) {
                  <a (click)="handleEventTableCreate(eventTypePageLink, selectedGroupCalendarId)" class="black-link">
                    {{ 'MEETING_SCHEDULER.MEETING_LIST.TEAM_EVENT_TYPE' | translate }}
                  </a>
                }
              </button>
            }
          </mat-menu>
        </div>
      }
    </div>
    <div class="pad-style">
      @if (isTableView && selectedToggle === 'events') {
        @if (personalCalendar$ | async; as personalCalendar) {
          <ng-template
            *ngTemplateOutlet="newEventTypeButton; context: { calendarId: personalCalendar.id }"
          ></ng-template>
          @if (!isTableView || selectedToggle === 'events') {
            <span class="button-container">
              <button mat-stroked-button color="primary" (click)="showCardView()">
                <mat-icon>view_module</mat-icon> {{ 'MEETING_SCHEDULER.MEETING_LIST.CARDVIEW' | translate }}
              </button>
              <button mat-flat-button color="primary" (click)="showTableView()">
                <mat-icon>view_headline</mat-icon> {{ 'MEETING_SCHEDULER.MEETING_LIST.TABLEVIEW' | translate }}
              </button>
            </span>
          }
        }
      }
    </div>

    <ng-template #newEventTypeButton let-calendarId="calendarId">
      <div class="personal-event-button">
        @if (!isTableView) {
          @if (eventTypePageLink$ | async; as eventTypePageLink) {
            <a [routerLink]="[eventTypePageLink, calendarId]">
              <button mat-flat-button color="primary">
                <mat-icon>add</mat-icon>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.NEW' | translate }}
              </button>
            </a>
          }
        }
      </div>
    </ng-template>

    @if (!isTableView) {
      <div>
        @if (isMobileScreen$ | async) {
          <mat-expansion-panel class="mat-elevation-z0 small-screen-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'MEETING_SCHEDULER.MEETING_LIST.MEETING_BOOKING_LINKS' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngTemplateOutlet="meetingTypes"></ng-container>
          </mat-expansion-panel>
        }
        @if ((isMobileScreen$ | async) === false) {
          <ng-container *ngTemplateOutlet="meetingTypes"></ng-container>
        }
        <ng-template #meetingTypes>
          <div class="row row-gutters">
            @if ((hasPersonalMeetingTypes$ | async) && (personalCalendar$ | async); as personalCalendar) {
              <div class="col col-xs-12 col-md-6 col-lg-4">
                <ng-template
                  *ngTemplateOutlet="
                    generalEventLinkCard;
                    context: {
                      url: personalCalendar.bookingUrl,
                      description: personalGeneralLinkDescription,
                      calendarId: personalCalendar.id,
                      slug: personalCalendar.slug || personalCalendar.id,
                      isGroup: false,
                    }
                  "
                ></ng-template>
              </div>
            }
            @for (eventType of personalMeetingTypes$ | async; track eventType; let i = $index) {
              <div class="col col-xs-12 col-md-6 col-lg-4">
                <ng-template *ngTemplateOutlet="eventTypeCard; context: { eventType: eventType }"></ng-template>
              </div>
            }
            @if ((hasPersonalMeetingTypes$ | async) === false && (personalCalendar$ | async); as personalCalendar) {
              <div class="col col-xs-12 col-md-6 col-lg-4">
                <ng-template
                  *ngTemplateOutlet="
                    noEventTypesCard;
                    context: {
                      titleTranslationKey: 'MEETING_SCHEDULER.MEETING_LIST.NO_MEETING_TYPES_TITLE',
                      calendarId: personalCalendar.id,
                    }
                  "
                ></ng-template>
              </div>
            }
          </div>
        </ng-template>
        <ng-template #noEventTypesCard let-titleTranslationKey="titleTranslationKey" let-calendarId="calendarId">
          <mat-card appearance="outlined" class="meeting-type-card">
            <mat-card-header>
              <mat-icon mat-card-avatar class="meeting-type-icon" [style.background-color]="noMeetingTypesColor">
                access_time
              </mat-icon>
              <mat-card-title>{{ titleTranslationKey | translate }}</mat-card-title>
              <mat-card-subtitle>
                {{ 'MEETING_SCHEDULER.MEETING_LIST.NO_MEETING_TYPES_SUBTITLE' | translate }}
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              @if (eventTypePageLink$ | async; as eventTypePageLink) {
                <a [routerLink]="[eventTypePageLink, calendarId]" style="margin-left: 165px">
                  <button mat-stroked-button class="create-event-button">
                    <mat-icon>add</mat-icon>
                    @if ((isMobileScreen$ | async) === false) {
                      <span> {{ 'MEETING_SCHEDULER.MEETING_LIST.CREATE_BOOKING_LINK' | translate }}</span>
                    }
                  </button>
                </a>
              }
            </mat-card-content>
          </mat-card>
        </ng-template>
        @if (hasGroupCalendars$ | async) {
          <div class="section-spacer"></div>
          <div class="team-event">
            <div class="section-header">
              <span class="section-header-text">{{ groupsSectionHeader }}</span>
              @if (selectedGroupCalendarId$$.asObservable() | async; as selectedGroupCalendarId) {
                <ng-template
                  *ngTemplateOutlet="
                    newEventTypeButton;
                    context: {
                      calendarId: selectedGroupCalendarId,
                    }
                  "
                ></ng-template>
              }
            </div>
            @if (context === MSContextType.MS_CONTEXT_PARTNER) {
              <div class="custom-team-container">
                <span class="custom-section-header"
                  >Team event links for
                  <span class="custom-section-header-team-name">{{ selectedGroupCalendarName$ | async }}</span></span
                >
                @if ((groupCalendars$ | async).length > 1) {
                  <div class="custom-select-dropdown">
                    <mat-label class="team-name-label">
                      {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_EVENT.LABEL' | translate }}
                    </mat-label>
                    @if ((groupCalendars$ | async).length > 1) {
                      <glxy-form-field size="default">
                        <mat-select
                          [value]="selectedGroupCalendarId$$.asObservable() | async"
                          (selectionChange)="changeSelectedGroupCalendarId($event)"
                        >
                          @for (groupCalendar of groupCalendars$ | async; track groupCalendar) {
                            <mat-option [value]="groupCalendar.id">
                              {{ groupCalendar.displayName }}
                            </mat-option>
                          }
                        </mat-select>
                      </glxy-form-field>
                    }
                  </div>
                }
              </div>
            }
            @if (isMobileScreen$ | async) {
              <mat-expansion-panel class="mat-elevation-z0 small-screen-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ 'MEETING_SCHEDULER.MEETING_LIST.MEETING_BOOKING_LINKS' | translate }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngTemplateOutlet="groupMeetingTypes"></ng-container>
              </mat-expansion-panel>
            }
            @if ((isMobileScreen$ | async) === false) {
              <ng-container *ngTemplateOutlet="groupMeetingTypes"></ng-container>
            }
          </div>
        } @else {
          <div class="section-spacer"></div>
          <div class="no-team-event">
            <div class="section-header">
              <span class="section-header-text">{{ groupsSectionHeader }}</span>
            </div>
            <div class="no-team-event-card">
              <mat-card class="no-team-card">
                <div class="no-team-section">
                  <img mat-card-image src="{{ NoTeamIcon }}" alt="NoTeam" class="no-sales-team-img" />
                  <mat-card-title class="no-sales-team-msg">{{
                    'MEETING_SCHEDULER.BOOKING_LINK.TEAM_EVENT.NO_TEAM_ASSIGNED.MESSAGE' | translate
                  }}</mat-card-title>
                </div>
              </mat-card>
            </div>
          </div>
        }
        <ng-template #groupMeetingTypes>
          <div class="row row-gutters">
            @if (
              (hasSelectedGroupMeetingTypes$ | async) && selectedGroupGeneralLink$ | async;
              as selectedGroupGeneralLink
            ) {
              <div class="col col-xs-12 col-md-6 col-lg-4">
                <ng-template
                  *ngTemplateOutlet="
                    generalEventLinkCard;
                    context: {
                      url: selectedGroupGeneralLink,
                      description: groupGeneralLinkDescription,
                      calendarId: selectedGroupCalendarId$$.getValue(),
                      slug: (selectedCalendar$ | async)?.slug || '',
                      isGroup: true,
                    }
                  "
                ></ng-template>
              </div>
            }
            @if ((hasSelectedGroupMeetingTypes$ | async) === false) {
              <div class="col col-xs-12 col-md-6 col-lg-4">
                <ng-template
                  *ngTemplateOutlet="
                    noEventTypesCard;
                    context: {
                      titleTranslationKey: 'MEETING_SCHEDULER.MEETING_LIST.NO_GROUP_MEETING_TYPES_TITLE',
                      calendarId: selectedGroupCalendarId$$.getValue(),
                    }
                  "
                ></ng-template>
              </div>
            }
            @for (eventType of selectedGroupMeetingTypes$ | async; track eventType; let i = $index) {
              <div class="col col-xs-12 col-md-6 col-lg-4">
                <ng-template *ngTemplateOutlet="eventTypeCard; context: { eventType: eventType }"></ng-template>
              </div>
            }
          </div>
        </ng-template>
      </div>
    }

    @if (isTableView && selectedToggle === 'events') {
      <div>
        <meeting-scheduler-group-and-service [selectedToggle]="selectedToggle"> </meeting-scheduler-group-and-service>
      </div>
    }
    @if (isTableView && selectedToggle === 'group') {
      <div>
        <meeting-scheduler-group-and-service [selectedToggle]="selectedToggle"> </meeting-scheduler-group-and-service>
      </div>
    }
    @if (isTableView && selectedToggle === 'service') {
      <div>
        <meeting-scheduler-group-and-service [selectedToggle]="selectedToggle"> </meeting-scheduler-group-and-service>
      </div>
    }
  </ng-template>

  <ng-template #calendarTemplate>
    <div class="section-spacer"></div>
    <div class="section-header">
      <span class="section-header-text">
        {{ 'MEETING_SCHEDULER.MEETING_LIST.SCHEDULED_EVENTS_SECTION_HEADER' | translate }}
      </span>
    </div>

    @if (meetings$ | async; as meetings) {
      <mat-tab-group
        (selectedIndexChange)="changedMeetingListTab($event)"
        class="meeting-list-tabs"
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        animationDuration="0ms"
      >
        <mat-tab label="{{ 'MEETING_SCHEDULER.MEETING_LIST.UPCOMING' | translate }}"></mat-tab>
        <mat-tab label="{{ 'MEETING_SCHEDULER.MEETING_LIST.PAST' | translate }}"></mat-tab>
      </mat-tab-group>
      @if ((meetings && meetings.length > 0) || meetingTypeFilter$$) {
        <div class="page-container">
          <div class="meeting-list-filters">
            <!--          TODO: Remove code along with calender View removal -->
            <!--          <meeting-scheduler-meeting-filter-->
            <!--            [meetingTypes]="allMeetingTypes$ | async"-->
            <!--            [selectedFilter]="selectedEventTypeFilter"-->
            <!--            (meetingTypeIdsSelected)="filterByMeetingTypeIds($event)"-->
            <!--          ></meeting-scheduler-meeting-filter>-->
            <div class="date-selector-style">
              @if (selectedTab === 'past') {
                <forms-time-range-selector
                  class="meeting-list-time-filter"
                  [timeRangeOption]="timeRangeKeySelected"
                  [timeRangeOptions]="timeRangeOptions"
                  [max]="now"
                  (dateRangeChange)="setDateRange($event)"
                  (timeRangeChange)="setTimeRangeKey($event)"
                ></forms-time-range-selector>
              }
            </div>
          </div>
          <div class="margin-top-component"></div>
          @if (meetings && meetings.length > 0) {
            <div class="pad-style">
              <mat-accordion>
                @for (meeting of dataSource$ | async; track meeting; let i = $index) {
                  @if (!isSameDate(meeting?.date.start | date: 'EEEE, MMM d, y', i)) {
                    <div class="date">
                      {{ meeting?.date.start | date: ' MMM d, y' }}
                    </div>
                  }
                  <mat-expansion-panel class="expansion-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="expansion-panel-title">
                        <div class="flex-class">
                          <div class="margin-right-10">
                            @if (meeting?.location === '' && meeting?.joinMeeting !== '') {
                              <mat-icon class="expansion-panel-header-icon">local_phone</mat-icon>
                            }
                            @if (meeting?.location !== '' && meeting?.joinMeeting === '') {
                              <mat-icon class="expansion-panel-header-icon">location_on</mat-icon>
                            }
                            @if (meeting?.location !== '' && meeting?.joinMeeting !== '') {
                              <mat-icon class="expansion-panel-header-icon">business</mat-icon>
                            }
                          </div>
                          <div>
                            <div class="title-name">{{ meeting.title }}</div>
                            <div class="subtitle-time">
                              {{ meeting.date.start | date: 'shortTime' }} - {{ meeting?.date.end | date: 'shortTime' }}
                            </div>
                            <div>{{ meeting?.guest || '-' }}</div>
                          </div>
                        </div>
                        <div (click)="stopPropagation($event)">
                          <div class="expansion-panel-header-button-group">
                            <button
                              mat-stroked-button
                              class="margin-right-10 expansion-panel-header-button-width"
                              [matMenuTriggerFor]="modifyMeeting"
                            >
                              <mat-icon class="edit-button-icon">edit</mat-icon> Edit
                            </button>
                            <mat-menu #modifyMeeting="matMenu" class="modify-meeting-menu">
                              <div>
                                <meeting-scheduler-reschedule-meeting-button
                                  [meeting]="meeting"
                                  [isMatItem]="true"
                                ></meeting-scheduler-reschedule-meeting-button>
                              </div>
                              <div>
                                <meeting-scheduler-cancel-meeting-button
                                  [meeting]="meeting"
                                  [isMatItem]="true"
                                  [displayText]="'Cancel'"
                                ></meeting-scheduler-cancel-meeting-button>
                              </div>
                            </mat-menu>
                            @if (meeting?.joinMeeting) {
                              <button
                                mat-flat-button
                                color="primary"
                                class="expansion-panel-header-button-width"
                                (click)="openMeetingLink(meeting?.joinMeeting)"
                              >
                                <mat-icon class="join-button-icon">video_call</mat-icon> Join
                              </button>
                            }
                          </div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="flex-class">
                      <div class="expansion-panel-body-item-width">
                        <div class="meeting-subtitle">
                          {{ 'MEETING_SCHEDULER.MEETING_LIST.CONTACT_LABEL' | translate }}
                        </div>
                        <div class="comment">
                          @if (meeting?.primaryContact?.contactId) {
                            <a class="contact-link" (click)="navigateToContact(meeting.primaryContact.contactId)">
                              {{ meeting.primaryContact.name || '—' }}
                            </a>
                          } @else {
                            {{ meeting?.primaryContact?.name || '—' }}
                          }
                        </div>
                      </div>
                      <div class="expansion-panel-body-item-width">
                        <div class="meeting-subtitle">
                          {{ 'MEETING_SCHEDULER.MEETING_LIST.EMAIL_LABEL' | translate }}
                        </div>
                        <div class="comment">
                          {{ meeting?.attendeeEmails || '—' }}
                        </div>
                      </div>
                    </div>
                    <div class="flex-class">
                      <div class="expansion-panel-body-item-width">
                        <div class="meeting-subtitle">
                          {{ 'MEETING_SCHEDULER.MEETING_LIST.PHONE_LABEL' | translate }}
                        </div>
                        <div class="comment">{{ meeting?.contact?.phoneNumber || '—' }}</div>
                      </div>
                      <div class="expansion-panel-body-item-width">
                        <div class="meeting-subtitle">
                          {{ 'MEETING_SCHEDULER.MEETING_LIST.LOCATION_LABEL' | translate }}
                        </div>
                        <div class="comment">
                          @if (meeting?.location) {
                            <mat-icon class="open-link-icon" (click)="openGoogleMaps(meeting?.location)">
                              open_in_new
                            </mat-icon>
                          }
                          <div>{{ meeting?.location || '—' }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-class">
                      <div class="expansion-panel-body-item-width">
                        <div class="meeting-subtitle">
                          {{ 'MEETING_SCHEDULER.MEETING_LIST.MEETING_LINK' | translate }}
                        </div>
                        <div class="comment">
                          @if (meeting?.joinMeeting) {
                            <mat-icon class="open-link-icon" (click)="openMeetingLink(meeting?.joinMeeting)">
                              open_in_new
                            </mat-icon>
                          }
                          <div>{{ meeting?.joinMeeting.toString() || '—' }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="meeting-subtitle">
                      {{ 'MEETING_SCHEDULER.MEETING_LIST.COMMENTS_LABEL' | translate }}
                    </div>
                    <div class="comment">{{ meeting?.comments || '—' }}</div>
                    @if (meeting?.formAnswers.length > 0) {
                      <div>
                        <div class="meeting-subtitle">
                          {{ 'MEETING_SCHEDULER.MEETING_LIST.CUSTOM_QUESTION_LABEL' | translate }}
                        </div>
                        @for (answer of meeting?.formAnswers; track answer) {
                          <div class="flex-item padding-left-10">
                            <div class="meeting-subtitle">{{ answer.label }}</div>
                            <div class="comment">{{ answer.answer.join(', ') }}</div>
                          </div>
                        }
                      </div>
                    }
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </div>
          } @else {
            <glxy-empty-state>
              <glxy-empty-state-hero>
                <img
                  src="https://vstatic-prod.apigateway.co/partner-center-client/assets/booking_empty_state.png"
                  alt="No meetings scheduled"
                />
              </glxy-empty-state-hero>
              <glxy-empty-state-title>
                {{ 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.UPCOMING_TITLE_V2' | translate }}</glxy-empty-state-title
              >
              <p>{{ 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.DESCRIPTION_V2' | translate }}</p>
            </glxy-empty-state>
          }
        </div>
      } @else {
        <glxy-empty-state>
          <glxy-empty-state-hero>
            <img
              src="https://vstatic-prod.apigateway.co/partner-center-client/assets/booking_empty_state.png"
              alt="No meetings scheduled"
            />
          </glxy-empty-state-hero>
          <glxy-empty-state-title>
            {{ 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.UPCOMING_TITLE_V2' | translate }}</glxy-empty-state-title
          >
          <p>{{ 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.DESCRIPTION_V2' | translate }}</p>
        </glxy-empty-state>
      }
    } @else {
      <ng-container *ngTemplateOutlet="loader"></ng-container>
    }

    <ng-template
      #generalEventLinkCard
      let-url="url"
      let-description="description"
      let-calendarId="calendarId"
      let-isGroup="isGroup"
      let-slug="slug"
    >
      <mat-card appearance="outlined" class="meeting-type-card">
        <mat-card-header>
          <mat-icon mat-card-avatar class="meeting-type-icon general-event-link-icon">all_inclusive</mat-icon>
          <mat-card-title>General event link</mat-card-title>
          <mat-card-subtitle>{{ description }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <mat-menu #meetingTypeMenu="matMenu">
            @if (calendarPageLink$ | async; as calendarPageLink) {
              <a mat-menu-item [routerLink]="[calendarPageLink + '/' + calendarId]" class="meeting-type-menu-item">
                <mat-icon>settings</mat-icon>
                {{ 'MEETING_SCHEDULER.MEETING_LIST.EDIT_URL' | translate }}
              </a>
            }
            <a
              mat-menu-item
              [href]="url"
              i18n="@@MEETING_SCHEDULER.MEETING_LIST.VIEW_LINK"
              target="_blank"
              class="meeting-type-menu-item"
            >
              <mat-icon>launch</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.VIEW_LINK' | translate }}
            </a>
          </mat-menu>

          <div class="button-container">
            <button mat-stroked-button [matMenuTriggerFor]="meetingTypeMenu" class="event-menu">
              <mat-icon class="more-icon-style">more_vert</mat-icon>
            </button>

            <button
              mat-stroked-button
              (click)="handleCopyMeetingLinkClicked($event, url)"
              [attr.aria-role]="'link'"
              [cdkCopyToClipboard]="url"
              class="copy-event-button"
            >
              <mat-icon>content_copy</mat-icon>
              @if ((isMobileScreen$ | async) === false) {
                <span>{{ 'MEETING_SCHEDULER.MEETING_LIST.COPY_LINK' | translate }}</span>
              }
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-template>

    <ng-template #eventTypeCard let-eventType="eventType">
      <mat-card appearance="outlined" class="meeting-type-card">
        <mat-card-header>
          <mat-icon mat-card-avatar class="meeting-type-icon" [style.background-color]="eventType.hexColor">
            access_time
          </mat-icon>
          <mat-card-title>{{ eventType.name }}</mat-card-title>
          <mat-card-subtitle>{{ toMinutes(eventType.duration) }} minutes</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <mat-menu #meetingTypeMenu="matMenu">
            @if (eventTypePageLink$ | async; as eventTypePageLink) {
              <a
                mat-menu-item
                (click)="handleView(eventTypePageLink, eventType.calendarId, eventType.id)"
                i18n="@@MEETING_SCHEDULER.MEETING_LIST.SETTINGS"
                class="meeting-type-menu-item"
              >
                <mat-icon>settings</mat-icon>
                {{ 'MEETING_SCHEDULER.MEETING_LIST.SETTINGS' | translate }}
              </a>
            }
            <a
              mat-menu-item
              [href]="eventType.bookingUrl"
              i18n="@@MEETING_SCHEDULER.MEETING_LIST.VIEW_LINK"
              target="_blank"
              class="meeting-type-menu-item"
            >
              <mat-icon>launch</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.VIEW_LINK' | translate }}
            </a>
            <button
              mat-menu-item
              [cdkCopyToClipboard]="eventType.bookingUrl"
              (click)="handleDeleteMeetingLinkClicked(eventType.id)"
              i18n="@@MEETING_SCHEDULER.MEETING_LIST.DELETE_LINK"
              class="meeting-type-menu-item"
            >
              <mat-icon>delete</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.DELETE_LINK' | translate }}
            </button>
          </mat-menu>

          <div class="button-container">
            <button mat-stroked-button [matMenuTriggerFor]="meetingTypeMenu" class="event-menu">
              <mat-icon class="more-icon-style">more_vert</mat-icon>
            </button>
            <button
              mat-stroked-button
              (click)="handleCopyMeetingLinkClicked($event, eventType.bookingUrl)"
              [attr.aria-role]="'link'"
              [cdkCopyToClipboard]="eventType.bookingUrl"
              class="copy-event-button"
            >
              <mat-icon>content_copy</mat-icon>
              @if ((isMobileScreen$ | async) === false) {
                <span>{{ 'MEETING_SCHEDULER.MEETING_LIST.COPY_LINK' | translate }}</span>
              }
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </ng-template>
</div>
